import type { OrderProduct, ProductGift } from "../OrderProduct.js";
import type { Product } from "../Product.js";

export function transformProductToOrderProduct(
	id: string,
	{ name, price, id: productId }: Product,
	quantity: number,
	gifts?: ProductGift[],
): OrderProduct {
	return {
		id,
		name,
		price,
		productId,
		quantity,
		gifts,
	};
}
